export const APP_RELEASE = __APP_RELEASE__

// Per account and browser. Do not let signing out, another tab, or a failed
// storage write interrupt playback or repeatedly reopen notes this session.
const acknowledged = new Set<string>()

export function releaseStorageKey(userId: number, version: string): string {
  return `tunes.release-seen.${userId}.${version}`
}

export function hasSeenRelease(key: string): boolean {
  if (acknowledged.has(key)) return true
  try {
    return localStorage.getItem(key) === '1'
  } catch {
    return false
  }
}

export function markReleaseSeen(key: string): void {
  acknowledged.add(key)
  try {
    localStorage.setItem(key, '1')
  } catch {
    // Still acknowledged for this session when browser storage is unavailable.
  }
}
